import pino from 'pino';

import { toJSTimestamp } from './helpers';

export const Logger = pino({
  browser: {
    formatters: {
      level(label) {
        return { level: label };
      },
      log(log: any) {
        if (Number.isInteger(log.time)) {
          return {
            ...log,
            time: new Date(toJSTimestamp(log.time)).toLocaleTimeString(),
          };
        }
        return log;
      },
    },
  },
  level: 'debug',
});

export const loggingVideoError = (e: Event) => {
  const videoElement = e.target as HTMLVideoElement;
  const { error } = videoElement;

  // Handle other standard media errors
  switch (error?.code) {
    case MediaError.MEDIA_ERR_ABORTED:
      Logger.warn('Video loading aborted');
      break;
    case MediaError.MEDIA_ERR_NETWORK:
      Logger.warn('Network error while loading video');
      break;
    case MediaError.MEDIA_ERR_DECODE:
      Logger.warn('Video decode error');
      break;
    case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
      Logger.warn('Video format not supported');
      break;
    default:
      Logger.error(videoElement?.error || error?.message);
  }
};
